export const LIST_USER_REQUEST = "@@adminReducer/LIST_USER_REQUEST";
export const LIST_USER_SUCCESS = "@@adminReducer/LIST_USER_SUCCESS";
export const LIST_USER_FAIL = "@@adminReducer/LIST_USER_FAIL";

export const EDIT_USER = "EDIT_USER";

